<template>
  <div class="main-content">
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
    <div v-if="!loading && orders">
      <div class="card">
        <div class="card-header bg-success"><h6><i class="icon-fa icon-fa-check"></i> Доставлены</h6></div>
        <div class="card-body">
          <table class="table table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Адрес/Препараты</th>
              <th>Сумма</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(order, index) in orders">
              <OrderTableView
                :order="order"
                :index="index"
                :salaryRates="salaryRates"
              />
              <tr>
                <td colspan="10">
                  <div v-if="actions[order.id].orderCorrectionOpen">
                    <div class="input-group mb-3">
                      <input type="text" v-model="actions[order.id].correction" placeholder="Данные для коррекции"
                             class="form-control"/>
                      <LoadingButton
                        title="Отправить"
                        color="#5BBFDE"
                        className="btn btn-outline-success"
                        :loading="actions[order.id].loading"
                        :onClick="() => updateOrder('send_correction', order.id)"
                      />
                    </div>
                  </div>
                  <div v-if="actions[order.id].salaryRateChange">
                    <p><strong>Отправить запрос на смену расчет ЗП</strong></p>
                    <div class="input-group mb-3">
                      <select v-model="actions[order.id].newSalaryRate" class="form-control">
                        <option value="0">Стандарт</option>
                        <option value="1">Область</option>
                        <option value="2">Дальняя</option>
                      </select>
                      <input type="text" v-model="actions[order.id].comment"
                             placeholder="Комментарий по необходимости"
                             class="form-control"/>
                      <LoadingButton
                        title="Отправить запрос"
                        color="#5BBFDE"
                        className="btn btn-outline-success"
                        :loading="actions[order.id].loading"
                        :onClick="() => updateOrder('send_salary_correction', order.id)"
                      />
                    </div>
                  </div>
                  <dropdown-menu menu-title="" dark-mode="auto" class="menu">
                    <section @click="openDialog(order.id, 'orderCorrectionOpen')" class="option">
                      <button><strong>Коррекция</strong></button>
                      <span class="desc">изменения кол. смена адреса, статуса и тд</span>
                    </section>
                    <section @click="openDialog(order.id, 'salaryRateChange')" class="option">
                      <button><strong>Смена ставки ЗП</strong></button>
                      <span class="desc">изменения стаки ЗП - высокая, область</span>
                    </section>
                  </dropdown-menu>
                </td>
              </tr>
              <tr class="divider">
                <td colspan="10"></td>
              </tr>
            </template>
            </tbody>
          </table>
          <div class="text-right">
            <p>Всего: <strong>{{ total.total }}</strong></p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && shifted && shifted.length">
      <div class="card">
        <div class="card-header bg-info"><h6><i class="icon-fa icon-fa-refresh"></i> Переносы</h6></div>
        <div class="card-body">
          <table class="table table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Адрес/Препараты</th>
              <th>Сумма</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(order, index) in shifted">
              <template v-if="loadingOrders[order.id]">
                <tr>
                  <td colspan="10">
                    <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
                  </td>
                </tr>
              </template>
              <template v-else>
                <OrderTableView
                  :order="order"
                  :index="index"
                  :salaryRates="salaryRates"
                />
              </template>
              <tr>
                <td colspan="10">
                  <dropdown-menu menu-title="" dark-mode="auto" class="menu">
                    <section @click="updateOrder('restore_order', order.id)" class="option">
                      <button><strong>Восстановить</strong></button>
                      <span class="desc">заявка появляется в общем списке</span>
                    </section>
                  </dropdown-menu>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="!loading && rejected && rejected.length">
      <div class="card">
        <div class="card-header bg-warning"><h6><i class="icon-fa icon-fa-warning"></i> Отказы</h6></div>
        <div class="card-body">
          <table class="table table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Адрес/Препараты</th>
              <th>Сумма</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(order, index) in rejected">
              <template v-if="loadingOrders[order.id]">
                <tr>
                  <td colspan="10">
                    <pulse-loader :loading="true" :color="loadingColor" class="text-center"/>
                  </td>
                </tr>
              </template>
              <template v-else>
                <OrderTableView
                  :order="order"
                  :index="index"
                  :salaryRates="salaryRates"
                />
              </template>
              <tr>
                <td colspan="10">
                  <dropdown-menu menu-title="" dark-mode="auto" class="menu">
                    <section @click="updateOrder('restore_order', order.id)" class="option">
                      <button><strong>Восстановить</strong></button>
                      <span class="desc">заявка появляется в общем списке</span>
                    </section>
                  </dropdown-menu>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import moment from "moment";
import OrderTableView from "./components/OrderTableView";
import DropdownMenu from "./components/DropDown"
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    OrderTableView,
    DropdownMenu,
    LoadingButton,
  },
  data() {
    return {
      orders: null,
      actions: {},
      rejected: null,
      shifted: null,
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      total: {},
      salaryRates: {},
      loadingOrders: {},
      defaultState: {
        orderCorrectionOpen: false,
        newSalaryRate: 0,
        comment: null,
        question: null,
        correction: null,
        rejectComment: null,
        loading: false,
      }

    }
  },
  created() {
    this.getReport();
  },
  methods: {
    openDialog(orderId, index) {
      this.closeOrderDialog(orderId);
      this.actions[orderId][index] = true;
    },
    closeOrderDialog(orderId) {
      this.actions[orderId] = {...this.defaultState}
    },
    async updateOrder(action, orderId) {
      if (this.loadingOrders[orderId]) return;
      this.loadingOrders[orderId] = true;
      const {data} = await api.post('orders/updateOrderByRunner', {
        type: action,
        order_id: orderId,
        data: this.actions[orderId]
      })
      if (data.success) {
        this.rejected = this.rejected.filter((o) => o.id !== orderId);
        toastr["success"]("Сохранено", "Успешно");
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.actions[orderId] = {...this.defaultState};
      this.loadingOrders[orderId] = false;
    },
    async getReport() {
      this.loading = true;
      const {data} = await api.index('orders/gerRunnerReport');
      if (data.success) {
        let loadingOrders = {};
        ([...data.rejected, ...data.shifted]).map((o) => {
          loadingOrders[o.id] = false;
        })
        const actionBtnLoading = {};
        const actions = {};
        this.total = data.orders.reduce((acc, o) => {
          actionBtnLoading[o.id] = false;
          actions[o.id] = {...this.defaultState}

          acc.total += o.price;
          acc.delivery += o.delivery_price;
          acc.orders += (o.price - o.delivery_price);
          return acc;
        }, {
          orders: 0,
          delivery: 0,
          total: 0
        });
        this.actionBtnLoading = {...actionBtnLoading};
        this.actions = {...actions};

        this.loadingOrders = loadingOrders;
        this.salaryRates = data.salary_rates;
        this.shifted = data.shifted;
        this.orders = data.orders;
        this.rejected = data.rejected;
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.loading = false;
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}
</script>

<style scoped>
tr.divider {
  background-color: #dedede;
}

p {
  margin-bottom: 3px;
}

table.table {
  margin-top: 0;
}

table.drugs_table tbody td {
  /*border: none;*/
  /*border-bottom: 1px solid #dee2e6;*/
}
</style>
